import { render, staticRenderFns } from "./Logos.vue?vue&type=template&id=7cf46134&scoped=true"
import script from "./Logos.vue?vue&type=script&lang=js"
export * from "./Logos.vue?vue&type=script&lang=js"
import style0 from "./Logos.vue?vue&type=style&index=0&id=7cf46134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf46134",
  null
  
)

export default component.exports